import { Component, Input, OnInit } from "@angular/core";
import { ControlContainer, NG_VALUE_ACCESSOR } from "@angular/forms";
import { InputBaseComponent } from "../../base/input-base.component";

@Component({
  selector: "tva-datepicker",
  templateUrl: "./tv-action-datepicker.component.html",
  styleUrls: ["./tv-action-datepicker.component.scss"],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TvActionDatepickerComponent,
    multi: true
  }]
})
export class TvActionDatepickerComponent
  extends InputBaseComponent
  implements OnInit {
  @Input() label;

  constructor() {
    super();
  }

  ngOnInit(): void { }
}
